import React from 'react'
import { StyledNavLink } from '../components/styled-components/route'

export const BiographyProfile = () => {
    return <StyledNavLink to="/contributions">Contributions</StyledNavLink>
}